import React, { type ReactNode } from 'react';

import { cssMap, cx } from '@atlaskit/css';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

type ContentMenuProps = {
	children?: ReactNode;
	label?: ReactNode;
};

const styles = cssMap({
	heading: {
		paddingBlock: token('space.100'),
		paddingLeft: token('space.075'),
		paddingTop: token('space.100'),
		paddingBottom: token('space.100'),
		color: token('color.text.subtle'),
		font: token('font.body'),
		fontWeight: token('font.weight.semibold'),
		display: 'flex',
		alignItems: 'center',
	},
});

// MenuSection is responsible for seperating logical groups of menu items.
// it is primarily used to seperate the promoted site from the rest of the menu items.
export const MenuSection = ({ children, label }: ContentMenuProps): React.JSX.Element => {
	return (
		<Flex direction="column">
			{label && <Box xcss={cx(styles.heading)}>{label}</Box>}
			{children}
		</Flex>
	);
};
